import type { Dayjs } from 'dayjs';
import { describePeriod, periodFromRange } from '@prerender/design-system/DateRangePicker';

import { DATE_RANGE_PRESETS } from './dateRangePresets';

export const CUSTOM_PERIOD_LABEL = 'Custom period';

export function describeDateRange(from: Dayjs, to: Dayjs): string {
  return describePeriod(periodFromRange(from, to, DATE_RANGE_PRESETS), DATE_RANGE_PRESETS) ?? CUSTOM_PERIOD_LABEL;
}

/** Mixpanel reports already group `time_frame` on these lower-case spellings; changing them splits each range's history. */
export function timeFrameNameForAnalytics(pickerName: string): string {
  return (pickerName === 'custom' ? CUSTOM_PERIOD_LABEL : pickerName).toLowerCase();
}

export function timeFrameForAnalytics(from: Dayjs, to: Dayjs): string {
  return timeFrameNameForAnalytics(describeDateRange(from, to));
}
